import React from 'react';
import cn from 'classnames';
import { Tag } from 'antd';
import BindTitle from '../BindTitle/BindTitle';
import BindsRow from '../BindsRow/BindsRow';
import Bind from '../Bind/Bind';
import useRequestAddresses from '../../../../../../queries/useRequestAddresses';
import styles from './RoomBinds.module.scss';

const getHouseTitle = (houseBind) =>
  [houseBind.house, houseBind.corpus && `к. ${houseBind.corpus}`]
    .filter(Boolean)
    .join(', ');

const getRoomTitle = (roomBind, roomsMap) => {
  const address = roomBind.address || roomBind;
  const room = roomsMap.get(address.id) || address;
  const typeShortName = room.typeShortName?.trim();
  const roomName = room.flat || room.name || room.addressName || address.flat;

  return [typeShortName, roomName].filter(Boolean).join(' ');
};

const RoomsGroup = ({ houseBind }) => {
  const { data: rooms } = useRequestAddresses(houseBind.houseId, {
    staleTime: Infinity,
    enabled: Boolean(houseBind.houseId),
  });

  const roomsMap = new Map((rooms || []).map((room) => [room.id, room]));

  return (
    <Tag
      key={getHouseTitle(houseBind)}
      className={cn(styles.container, styles.roomContainer)}
      color="#fdfdfd"
    >
      {getHouseTitle(houseBind)}
      <BindsRow
        size="md"
        className={styles.row}
      >
        {houseBind.rooms.map((roomBind) => (
          <Bind
            key={roomBind.id}
            color="#00ad5d"
            item={roomBind}
            content={getRoomTitle(roomBind, roomsMap)}
            small
          />
        ))}
      </BindsRow>
    </Tag>
  );
};

const RoomBinds = ({ binds }) => {
  return (
    <div>
      <BindTitle>Помещения</BindTitle>
      <BindsRow size="lg">
        {binds.map((bind) => (
          <Tag
            key={bind.streetName}
            className={styles.container}
          >
            {bind.streetName}
            <BindsRow
              size="md"
              className={styles.row}
            >
              {bind.houses.map((houseBind) => (
                <RoomsGroup
                  key={`${houseBind.houseId}-${getHouseTitle(houseBind)}`}
                  houseBind={houseBind}
                />
              ))}
            </BindsRow>
          </Tag>
        ))}
      </BindsRow>
    </div>
  );
};

export default RoomBinds;
